export const countiesList = [
    { "id": "1", "name": "Alba" },
    { "id": "2", "name": "Arad" },
    { "id": "3", "name": "Arges" },
    { "id": "4", "name": "Bacau" },
    { "id": "5", "name": "Bihor" },
    { "id": "6", "name": "Bistrita-Nasaud" },
    { "id": "7", "name": "Botosani" },
    { "id": "8", "name": "Braila" },
    { "id": "9", "name": "Brasov" },
    { "id": "42", "name": "Bucuresti" },
    { "id": "10", "name": "Buzau" },
    { "id": "11", "name": "Calarasi" },
    { "id": "12", "name": "Carasi-Severin" },
    { "id": "13", "name": "Cluj" },
    { "id": "14", "name": "Constanta" },
    { "id": "15", "name": "Covasna" },
    { "id": "16", "name": "Dambovita" },
    { "id": "17", "name": "Dolj" },
    { "id": "18", "name": "Galati" },
    { "id": "19", "name": "Giurgiu" },
    { "id": "20", "name": "Gorj" },
    { "id": "21", "name": "Harghita" },
    { "id": "22", "name": "Hunedoara" },
    { "id": "23", "name": "Ialomita" },
    { "id": "24", "name": "Iasi" },
    { "id": "25", "name": "Ilfov" },
    { "id": "26", "name": "Maramures" },
    { "id": "27", "name": "Mehedinti" },
    { "id": "28", "name": "Mures" },
    { "id": "29", "name": "Neamt" },
    { "id": "30", "name": "Olt" },
    { "id": "31", "name": "Prahova" },
    { "id": "32", "name": "Salaj" },
    { "id": "33", "name": "Satu Mare" },
    { "id": "34", "name": "Sibiu" },
    { "id": "35", "name": "Suceava" },
    { "id": "36", "name": "Teleorman" },
    { "id": "37", "name": "Timis" },
    { "id": "38", "name": "Tulcea" },
    { "id": "39", "name": "Valcea" },
    { "id": "40", "name": "Vaslui" },
    { "id": "41", "name": "Vrancea" },
    { "id": "99", "name": "Altele" }
]